export default function (getEnquiries, getVehicleDetails, $q) {
    const vm = this;

    vm.isLoadingVehicles = false;
    vm.isLoadingEnquiries = false;
    vm.errorsOccurredLoadingEnquiries = false;
    vm.errorsOccurredLoadingVehicles = false;
    vm.searchTerm = '';
    vm.vehicle = null;
    vm.enquiries = [];

    /* --- */

    vm.search = search;

    /* --- */

    function search(searchTerm) {
        vm.errorsOccurredLoadingEnquiries = false;
        vm.errorsOccurredLoadingVehicles = false;
        vm.vehicle = null;
        vm.enquiries = [];
        if (searchTerm === '') {
            return;
        }
        $q.all([
            requestEnquiries(searchTerm)
        ]);
    }

    function requestEnquiries(searchTerm) {
        vm.isLoadingEnquiries = true;
        return getEnquiries(searchTerm)
                .then(records => {
                    vm.enquiries = records;
                })
                 .then(() => {
                     vm.isLoadingEnquiries = false;
                 })
                .catch(() => {
                    vm.isLoadingEnquiries = false;
                    vm.errorsOccurredLoadingEnquiries = true;
                });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/enquiries/list/enquiriesListCtrl.js